import React from "react";
import {
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import ErrorIcon from "@mui/icons-material/Error";
import { format } from "date-fns";

const formatCurrency = (amount, currency = "INR") =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency,
  }).format(amount / 100);

const formatDate = (date) =>
  format(new Date(date), "dd MMM yyyy");

const shortId = (id = "") =>
  id.length > 30 ? `${id.slice(0, 8)}...${id.slice(-6)}` : id;

const getPaymentStatus = (txn) => {
  if (txn.payment_status !== "succeeded") {
    return {
      label: "Failed",
      color: "error",
      icon: <ErrorIcon fontSize="small" />,
    };
  }

  return {
    label: "Paid",
    color: "success",
    icon: <CheckCircleIcon fontSize="small" />,
  };
};

const getProcessingStatus = (txn) => {
  if (txn.processed) {
    return {
      label: "Completed",
      color: "success",
      icon: <CheckCircleIcon fontSize="small" />,
    };
  }

  return {
    label: "Pending confirmation",
    color: "primary",
    icon: <HourglassTopIcon fontSize="small" />,
  };
};

const TransactionTable = ({ transactions = [], onRowClick }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "none",
      }}
    >
      <Table>
        {/* Header */}
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700 }}>Purchase</TableCell>
            {/* <TableCell sx={{ fontWeight: 700 }}>Qty</TableCell> */}
            <TableCell sx={{ fontWeight: 700 }}>Amount</TableCell>

            {/* SEPARATE COLUMNS */}
            <TableCell sx={{ fontWeight: 700 }}>Payment Status</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Processing Status</TableCell>

            <TableCell sx={{ fontWeight: 700 }}>Date</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Transaction ID</TableCell>
          </TableRow>
        </TableHead>

        {/* Body */}
        <TableBody>
          {transactions.map((txn) => {
            const addon = txn.addon;
            const payment = getPaymentStatus(txn);
            const processing = getProcessingStatus(txn);

            return (
               <TableRow
          key={txn.transaction_id}
          hover
          onClick={() => onRowClick?.(txn)}
          sx={{
            cursor: onRowClick ? "pointer" : "default",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.02)",
            },
          }}
        >
                {/* Purchase */}
                <TableCell>
                  <Typography fontWeight={700} variant="body2">
                    {addon?.addon_name || "Purchase"}
                  </Typography>

                  <Typography variant="caption" color="text.secondary">
                    {txn.transaction_type}
                  </Typography>
                </TableCell>

                {/* Qty */}
                {/* <TableCell>
                  <Typography fontWeight={600}>
                    {addon?.quantity ?? "-"}
                  </Typography>
                </TableCell> */}

                {/* Amount */}
                <TableCell>
                  <Typography fontWeight={800}>
                    {formatCurrency(txn.total_amount, txn.currency)}
                  </Typography>
                </TableCell>

                {/* PAYMENT STATUS */}
                <TableCell>
                  <Chip
                    size="small"
                    icon={payment.icon}
                    label={payment.label}
                    color={payment.color}
                  />
                </TableCell>

                {/* PROCESSING STATUS */}
                <TableCell>
                  <Chip
                    size="small"
                    icon={processing.icon}
                    label={processing.label}
                    color={processing.color}
                  />
                </TableCell>

                {/* Date */}
                <TableCell>
                  <Typography variant="body2" color="text.secondary">
                    {formatDate(txn.transaction_date)}
                  </Typography>
                </TableCell>

                {/* Transaction ID */}
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>
                    {shortId(txn.transaction_id)}
                  </Typography>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TransactionTable;